import { alpha, ListItem, Typography, useTheme } from '@mui/material';

import Exit from '@/shared/ui/icons/Exit.svg';

import { useLogout } from '../model/useLogout';

interface IProps {
  widthText: boolean;
}
const ICON_SIZE = 24;

/**
 * Кнопка разлогина
 * @param root0 - пропсы компонента
 * @param root0.widthText - будет ли рядом с кнопкой дополнительный текст
 */
export const LogoutButton = ({ widthText }: IProps) => {
  const logout = useLogout();
  const { palette } = useTheme();

  return (
    <ListItem
      onClick={() => logout(true)}
      sx={{
        display: 'flex',
        cursor: 'pointer',
        gap: 2,
        transition: 'all 0.3s ease-in-out',
        width: 'calc(100% - 16px)',
        margin: '0 8px',
        borderRadius: 2,
        '&:hover': {
          backgroundColor: alpha(palette.common.white, 0.1)
        }
      }}
    >
      <Exit
        style={{
          width: ICON_SIZE,
          height: ICON_SIZE,
          minWidth: ICON_SIZE,
          minHeight: ICON_SIZE
        }}
      />
      {widthText && (
        <Typography variant='subtitle2' color='white'>
          Выход
        </Typography>
      )}
    </ListItem>
  );
};
